import * as React from 'react';
import { createViewConfig, view } from '@sail/engine';
import { styles } from './GridLinesStyles';
export const GridLinesConfig = createViewConfig({
    name: 'GridLines'
});
/**
 * The component that renders the grid lines used in the background of pages.
 */ export const GridLines = GridLinesConfig.createView(()=>{
    return /*#__PURE__*/ React.createElement(view.div, {
        uses: [
            styles.gridLines
        ]
    }, /*#__PURE__*/ React.createElement(view.div, {
        uses: [
            styles.gridLinesContainer
        ]
    }, /*#__PURE__*/ React.createElement(view.div, {
        uses: [
            styles.gridLine
        ]
    }), /*#__PURE__*/ React.createElement(view.div, {
        uses: [
            styles.gridLine
        ]
    }), /*#__PURE__*/ React.createElement(view.div, {
        uses: [
            styles.gridLine
        ]
    }), /*#__PURE__*/ React.createElement(view.div, {
        uses: [
            styles.gridLine
        ]
    }), /*#__PURE__*/ React.createElement(view.div, {
        uses: [
            styles.gridLine
        ]
    })));
});

//# sourceMappingURL=GridLines.js.map